import React, { useState } from 'react';
import Image from 'components/AppImage';


const leaderboardData = [
{
  rank: 1,
  name: "Sarah Mitchell",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b98e6da6-1772609107086.png",
  avatarAlt: "Professional woman with brown hair smiling in gym attire",
  score: 98,
  visits: 28,
  streak: 21,
  badge: "Champion",
  badgeColor: "#EA580C"
},
{
  rank: 2,
  name: "James Thornton",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d90be6dd-1763295513019.png",
  avatarAlt: "Athletic man with short dark hair wearing workout shirt",
  score: 94,
  visits: 26,
  streak: 18,
  badge: "Elite",
  badgeColor: "#0F766E"
},
{
  rank: 3,
  name: "Priya Sharma",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d6fb6b21-1772609107966.png",
  avatarAlt: "Young woman with long black hair in fitness clothing",
  score: 91,
  visits: 24,
  streak: 15,
  badge: "Elite",
  badgeColor: "#0F766E"
},
{
  rank: 4,
  name: "Marcus Johnson",
  avatar: "https://images.unsplash.com/photo-1691882954715-a1fa750d7eab",
  avatarAlt: "Muscular man with bald head in black tank top",
  score: 87,
  visits: 22,
  streak: 12,
  badge: "Active",
  badgeColor: "#0D9488"
},
{
  rank: 5,
  name: "Emily Chen",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17793e900-1772609106618.png",
  avatarAlt: "Asian woman with short hair smiling in gym environment",
  score: 83,
  visits: 20,
  streak: 10,
  badge: "Active",
  badgeColor: "#0D9488"
},
{
  rank: 6,
  name: "David Park",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17cdba1be-1772609107467.png",
  avatarAlt: "Korean man with glasses wearing casual athletic wear",
  score: 79,
  visits: 18,
  streak: 8,
  badge: "Regular",
  badgeColor: "#6B7280"
}];


const EngagementLeaderboard = () => {
  const [view, setView] = useState('score');

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-4 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm lg:text-base font-semibold font-heading text-[var(--color-foreground)]">
          Engagement Leaderboard
        </h3>
        <div className="flex bg-[var(--color-muted)] rounded-lg p-0.5">
          {['score', 'visits', 'streak']?.map((v) =>
          <button
            key={v}
            onClick={() => setView(v)}
            className={`px-2 py-1 rounded-md text-xs font-caption font-medium capitalize transition-all ${
            view === v ?
            'bg-[var(--color-card)] text-[var(--color-primary)] shadow-sm' :
            'text-[var(--color-muted-foreground)]'}`
            }>
            
              {v}
            </button>
          )}
        </div>
      </div>
      <div className="space-y-2">
        {leaderboardData?.map((member) =>
        <div
          key={member?.rank}
          className="flex items-center gap-3 p-2 rounded-lg hover:bg-[var(--color-muted)] transition-colors cursor-pointer">
          
            <span
            className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold font-heading flex-shrink-0 ${
            member?.rank === 1 ?
            'bg-amber-100 text-amber-700' :
            member?.rank === 2 ?
            'bg-gray-100 text-gray-600' :
            member?.rank === 3 ?
            'bg-orange-100 text-orange-700' : 'bg-[var(--color-muted)] text-[var(--color-muted-foreground)]'}`
            }>
            
              {member?.rank}
            </span>
            <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
              <Image
              src={member?.avatar}
              alt={member?.avatarAlt}
              className="w-full h-full object-cover" />
            
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium font-caption text-[var(--color-foreground)] truncate">
                {member?.name}
              </p>
              <span
              className="text-xs font-caption px-1.5 py-0.5 rounded-full"
              style={{
                backgroundColor: `${member?.badgeColor}18`,
                color: member?.badgeColor
              }}>
              
                {member?.badge}
              </span>
            </div>
            <div className="text-right flex-shrink-0">
              <p className="text-sm font-bold font-heading text-[var(--color-primary)]">
                {view === 'score' ?
              member?.score :
              view === 'visits' ?
              member?.visits :
              member?.streak}
              </p>
              <p className="text-xs text-[var(--color-muted-foreground)] font-caption">
                {view === 'score' ? 'pts' : view === 'visits' ? 'visits' : 'days'}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>);

};

export default EngagementLeaderboard;